<template>
  <div class="body-mobile">
    <index-header page="home"></index-header>
    <div style="width:100%;text-align:center;height:50px;position:fixed;bottom:0;left:0;">
				<template v-if="areaId==='510112'">
				Copyright {{new Date().getFullYear()}} <a href="http://www.lqjydsj.cn" style="color:#000;">www.lqjydsj.cn</a>  All Rights Reserved. 龙泉教育大数据 版权所有 蜀ICP备19007218号 | <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51011202000252" style="color:#000;">川公网安备51011202000252号</a> 
				</template>
				<template v-else>
				Copyright {{new Date().getFullYear()}} <a href="http://www.sxw.cn" style="color:#000;">www.sxw.cn</a>  All Rights Reserved. 生学教育 版权所有 蜀ICP备 16026065号 | <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002001905" style="color:#000;">川公网安备51019002001905号</a> 
				</template>
			</div>
		<div class="container-vertical-middle">

			<div class="welcome box-signup box-shadow">
				<h3 class="text-h3 signup-title" v-if="studentType === 1">欢迎访问{{areaName}}幼儿园报名系统</h3>
				<h3 v-else class="text-h3 signup-title">欢迎访问{{studentTypeName2}}网上信息采集系统</h3>
				<p v-if="studentType === 1&&areaId==='510112'" style="color:#ff0000;margin-bottom:.2rem;font-size:.24rem;">此次报名仅做资料登记，报名先后不代表录取顺序，请错开高峰期报名。</p>
        <h4 class="text-h4"><template v-if="timeText">网上{{sysName}}{{areaId==='510117'?'登记':''}}时间为{{timeText}}，请在此时间段内进行网上{{sysName}}</template></h4>

				<div class="box-tips">
					<h5 class="text-warning">{{infoText}}</h5>
				</div>
				<div>
					<!-- <md-agree
						v-model="agreeConf.checked"
						:disabled="agreeConf.disabled"
						:size="agreeConf.size">
						已阅读并接受<a @click="toggleDialog">《填报信息隐私保护协议》</a>
					</md-agree> -->

					<md-check :name="true" v-model="agreeConf.checked" label="已阅读并接受" style="float:left;font-size:.26rem;" />
				      <a @click="toggleDialog" style="line-height:30px;font-size:.26rem;" >{{ studentType === 1 ? '《幼儿园报名信息隐私保护协议》' : '《填报信息隐私保护协议》'}}</a>
				</div>

			</div>

			<div class="box-btns">
				<a href="javascript:void(0)" class="button-primary" @touchstart="beforeSignup">{{studentType === 2 ? '我要填报' : '马上报名'}}</a>
				<router-link class="button-primary-inset" :to='{path: "/mobile/login", query: {signupNoticeId}}'>{{studentType === 2 ? '我要查询' : '报名查询'}}</router-link>
			</div>
		</div>
		<div class="container-popup" v-show="isPopupShow">
			<div class="container-popup-inner">
				<span class="btn-close" @touchstart="toggleDialog">关闭</span>
				<div class="container-popup-wrapper">
					<div class="box-protocal" v-if="studentType === 1">
						<p class="sx-align-center">用户协议</p>
						欢迎使用{{areaName}}幼儿园报名系统（以下称之为报名系统），请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不使用，若您进入报名系统，则意味着您将自愿遵守以下规则，并完全同意{{areaName}}教育局管理您所报名的信息。
						一、总则
						1. 本系统命名为“{{areaName}}幼儿园报名系统”，以下简称“报名系统”。
						2. 本系协议最终解释权均属{{areaName}}教育局所有。
						二、隐私保护
						1. 凡是进行报名的用户皆为报名系统的用户。
						2. 报名填写的用户个人信息都受到隐私保护，不接受任何个人或单位的查询，司法、检察机关需要除外。
						3. 用户应对所提供的材料真实性负责，在入学安排过程中，发现提供虚假信息、证件、证明和其他材料弄虚作假者，一经查实将依法追究责任并取消入学资格。
					</div>
					<div class="box-protocal" v-else>
						<p class="sx-align-center">用户协议</p>欢迎使用{{areaName}}流动人员随迁子女网上信息采集系统（以下称之为采集系统），请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不使用，若您进入采集系统，则意味着您将自愿遵守以下规则，并完全同意{{areaName}}教育局管理您所填报的信息。

						一、总则
						1. 本系统命名为“{{areaName}}流动人员随迁子女网上信息采集系统”，以下简称“采集系统”。
						2. 本系协议最终解释权均属{{areaName}}教育局所有。
						二、隐私保护
						1. 凡是进行填报的用户皆为采集系统的用户。
						2. 采集的用户个人信息都受到隐私保护，不接受任何个人或单位的查询，司法、检察机关需要除外。
						3. 用户应对所提供的材料真实性负责，在入学安排过程中，发现提供虚假信息、证件、证明和其他材料弄虚作假者，一经查实将依法追究责任并取消入学资格。
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
	import PageIndex from '../index/mixins/page_index';
  import IndexHeader from './components/IndexHeader';

  export default {
    mixins: [IndexCommon, MobileCommon, PageIndex],
    components: {IndexHeader},
    data() {
      return {
				agreeConf: {
					checked: false,
					name: 'agree0',
					size: 'md',
					disabled: false,
					introduction: '选中状态'
				},

				isPopupShow: false
			}
    },
    created() {
      // PC访问不允许进入手机端
      if (!this.$store.state.isMobile) {
        this.$router.push('/index');
      }
		},

		methods: {
			beforeSignup() {
				if (this.agreeConf.checked) {
					this.hasRead = true;
					this.onClickSignup();
				} else {
					this.$message.error('请勾选已阅读并接受隐私保护协议');
				}
			},

			toggleDialog() {
				this.isPopupShow = !this.isPopupShow;
			}
		}
  }
</script>

<style lang="stylus" scoped>
	.container-vertical-middle
		margin-top 1rem
		top 45%
	.box-signup
		margin 0 30px
		background-color #fff
		border-radius 20px
		padding 80px 50px
	.signup-title
		margin 30px 0
	.box-tips
		padding 20px
		background-color #fbfbfb
	.box-btns
		.button-primary
			margin-right 50px
	.body-mobile
		background-image url('./images/bg2.png')

	.container-popup
		position absolute
		left 0
		right 0
		top 0
		bottom 0
		background rgba(0, 0, 0, .5);
		.container-popup-inner
			position absolute
			width 80%
			left 50%
			transform translateX(-50%)
			top 80px;
			bottom 80px
			padding 60px 40px
			border-radius 10px
			background-color #fff;
		.container-popup-wrapper
			padding-top 30px
			height 100%
			width 100%
			overflow-y auto
		.box-protocal
			white-space pre-line
			line-height 48px
			font-size 28px
		.btn-close
			float right
			position absolute
			right 20px
			top 20px
			font-size 28px
	.md-agree,
	.md-check-label
		font-size 26px
</style>
